import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/auth/auth.ts";
import { useStyles } from "@/hooks/useStyles";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type LogoutProps = {
  className?: string;
};

export const Logout: React.FC<LogoutProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <Button variant="outlined" className={cx(styles.container, className)} onClick={() => void logout()}>
      {t("auth.logout")}
    </Button>
  );
};

const makeStyles = () => ({
  container: css``,
});
